export class IndicacaoAmigo {
    nmRemetente: string = '';
    nmDestinatario: string = '';
    dsEmailDestinatario: string = '';
}
